export type ISettingsStore = typeof defaultStore;

export const defaultStore = {
  fetching: true,
  shortenerEnabled: false,
  applicationName: 'Link Manager & Shortener',
  theme: {
    primary: '#00A1E4',
    textPrimary: '#FFFFFF',
    secondary: '#FDBC5A',
    textSecondary: '#474F54',
  },
  archiveFilters: [] as string[],
  profileParameterName: 'Market',
  targetUrlParameterName: 'Target URL',
  customContentDataProtection: false,
  customContentImprint: false,
  showDataProtectionDe: false,
  parameterNameUsedInArchiveEntryHeader: [] as string[],
  styleHeaderImageUrl: '',
  version: {
    backend: '—',
    frontend: process.env.PACKAGE_VERSION || '—',
  },
  archiveViewType: 'list',
  archiveLinksPerPage: 10,
};



// WEBPACK FOOTER //
// ./src/services/settings/store.ts